var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialMoreBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 76,
    viewBox: "0 0 355 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 355,
    height: 76,
    rx: 15,
    fill: "url(#paint0_linear_262_13122)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266 39.6981H330M330 39.6981L314 24M330 39.6981L314 55.3962",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_262_13122",
    x1: 0,
    y1: 38,
    x2: 355,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#058A9F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialMoreBtn);
export default __webpack_public_path__ + "static/media/testimonial-more-btn.3352fa922da17b76053fa71ec304ac4d.svg";
export { ForwardRef as ReactComponent };